module.exports = __webpack_public_path__ + "static/media/logo_pc__web.7ead1956.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo_pc__web.png
// module id = 910
// module chunks = 0